import React from 'react';

import './MoodList.scss';

export interface IMoodListProps {
  moods: string[];
}

const MoodList = ({ moods }: IMoodListProps) => {
  const moodItems = moods.map(mood => (
    <li key={mood} className="mood">
      {mood}
    </li>
  ));

  return (
    <div className="mood-list">
      <h3 className="mood-list__title">Moods</h3>
      <ul className="mood-list__moods">{moodItems}</ul>
    </div>
  );
};

export default MoodList;
